import React, { useEffect, useState } from 'react';

import { Col, Row, Form } from 'react-bootstrap';

import './styles.css';

import Menu from '../../components/Menu';
import { Link, useHistory, useParams } from 'react-router-dom';
import api from '../../services/api';
import { useAlert } from 'react-alert';
import CropperModal from '../../components/CropperModal';
import { readFile } from '../../useful/helpers';

const NovaLocalizacao = () => {
  const [name, setName] = useState('');
  const [lat, setLat] = useState('');
  const [long, setLong] = useState('');
  const [address, setAddress] = useState('');
  const [formData, setFormData] = useState(null);
  const [load, setLoad] = useState(false);
  const [thumbnail, setThumbnail] = useState(null);
  const [show, setShow] = useState(false);


  const { id } = useParams();
  const alert = useAlert();
  const history = useHistory();

  useEffect(() => {
    setFormData(new FormData());
  }, []);


  const handleName = e => setName(e.target.value);
  const handleAddress = e => setAddress(e.target.value);
  const handleLat = e => setLat(e.target.value);
  const handleLong = e => setLong(e.target.value);



  const handleSubmit = async () => {
    setLoad(true);
    formData.append('name', name);
    formData.append('lat', lat);
    formData.append('long', long);
    formData.append('image', thumbnail);
    formData.append('address', address);
    formData.append('macumba_id', id);

    try {
      const { status } = await api.post('admin/location', formData);
      setLoad(false);
      if (status === 201) {
        alert.show("Dados adicionados com sucesso!");
        history.push(`/rota-macumba/edit/${id}`);
      }
    } catch ({ response }) {
      setLoad(false);
      const { status, data } = response;
      if (status === 401) {
        for (let item in data.message) {
          alert.show(data.message[item][0]);
        }
      }
    }

  }
  return (
    <div className="container-fluid">
      {load &&
        <div className="load">
          <div className="loading"></div>
        </div>
      }
      <Menu />
      <div className="content">
        <Row>
          <Col sm={12} className="col-title">
            <div className="titlePages">
              <h5>Localização</h5>
              <Link to={`/rota-macumba/edit/${id}`}>
                <button className="btnBorder">VOLTAR</button>
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Form className="formNew">
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Nome</Form.Label>
                    <Form.Control type="text" placeholder="Inserir aqui" name="name" value={name} onChange={handleName} />
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Endereço</Form.Label>
                    <Form.Control type="text" placeholder="Inserir aqui" name="address" value={address} onChange={handleAddress} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Latitude</Form.Label>
                    <Form.Control type="text" placeholder="Inserir aqui" name="name" value={lat} onChange={handleLat} />
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Longitude</Form.Label>
                    <Form.Control type="text" placeholder="Inserir aqui" name="address" value={long} onChange={handleLong} />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <hr className="hrBorder" />
        <Row>
          <Col sm={8}>
            <button className="btnYellow btnFloat" onClick={handleSubmit}>SALVAR</button>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default NovaLocalizacao;